import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from './NavMenu';
import { ErrorBoundary } from '../helpers/error-boundary';
import { Footer } from 'react-bootstrap/lib/Modal';

export class Layout extends Component {
  displayName = Layout.name

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={2}>
            <NavMenu />
          </Col>
          <Col md={10}>
            <ErrorBoundary>
              {this.props.children}
            </ErrorBoundary>
          </Col>
        </Row>
        <Footer>
          <Col md={12}>
            <p><i>Centar za pružanje usluga u zajednici Ozalj - Sva prava pridržana.</i></p></Col>
        </Footer>
      </Grid>
    );
  }
}
